import {
    Button
} from '@material-ui/core';
import React, { useRef, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { EXPORT_MODE_EXCEL, EXPORT_MODE_CSV } from 'config';
import { CSVLink } from 'react-csv/lib';
import {
    ExcelExport,
    ExcelExportColumn,
} from '@progress/kendo-react-excel-export';
import moment from 'moment';
import { profileURL } from 'config';
import { get10LastLetters } from 'utils/validations';

const useStyles = makeStyles(theme => ({
    csv: {
        display: 'none',
    },
    excel: {
        marginRight: 20,
        backgroundColor: '#040f40',
        padding: 10,
        color: '#fff',
        borderRadius: 15,
        '&:hover': {
            backgroundColor: '#00B0EC',
        },
    },
}));

const ExportCSV = ({
    filename,
    data,
    headers,
    loadExportData,
    exportType,
    setExportType
}) => {
    const classes = useStyles();
    const csvLink = useRef();
    const excelExporter = useRef();

    const datasource = data.map(item => ({
        ...item,
        id: get10LastLetters(item.id),
        avatar: item.picture === undefined ? '' : profileURL + item.picture,
        numLogin: Number.parseInt(item.numLogin || 0) + 1,
        lastLogin: item.lastLogin ? moment(item.lastLogin).format("HH:mm DD/MM/YYYY") : "",
        createdAt: moment(item.createdAt).format("HH:mm DD/MM/YYYY"),
        selfSignup: item.selfSignup ? "Oui" : "Non",
        emails: (item.emails || []).join(", ")
    }));

    useEffect(() => {
        if (exportType) {
            exportData(exportType)
        }
    }, [exportType]);

    const exportExcel = () => {
        if (data.length > 0) {
            return excelExporter.current.save();
        }
        loadExportData(1, EXPORT_MODE_EXCEL);
    };

    const exportCSV = () => {
        if (data.length > 0) {
            return csvLink.current.link.click();
        }
        loadExportData(1, EXPORT_MODE_CSV);
    };

    const exportData = (type) => {
        setTimeout(() => {
            if (type === EXPORT_MODE_EXCEL) {
                excelExporter.current.save();
            } else {
                csvLink.current.link.click();
            }
            setExportType();
        });
    };
    return (
        <React.Fragment>
            <Button onClick={exportExcel} classes={{ root: classes.excel }}>
                <FormattedMessage id="export_xls" />
            </Button>
            <Button onClick={exportCSV} classes={{ root: classes.excel }}>
                <FormattedMessage id="export_csv" />
            </Button>
            <CSVLink
                data={datasource}
                headers={headers}
                className={classes.csv}
                filename={`${filename}.csv`}
                ref={csvLink}
            >
                CSV
            </CSVLink>
            <ExcelExport
                data={datasource}
                fileName={`${filename}.xlsx`}
                ref={excelExporter}
            >
                {
                    headers.map(el => <ExcelExportColumn
                        key={el.key}
                        field={el.key}
                        title={el.label}
                        width={150}
                        cellOptions={{ fontSize: 12 }}
                        headerCellOptions={{ fontSize: 14 }}
                    />)
                }
            </ExcelExport>
        </React.Fragment>
    );
};
ExportCSV.propTypes = {
    filename: PropTypes.string,
    data: PropTypes.any,
    headers: PropTypes.any,
    loadExportData: PropTypes.func,
    exportType: PropTypes.string,
    setExportType: PropTypes.func
};
export default ExportCSV;
